var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "orders",
    transform: "translate(-924.000000, -413.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "table",
    transform: "translate(224.000000, 202.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(40.000000, 207.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "new_icon",
    transform: "translate(660.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#3796F6",
    strokeWidth: 1.33333333,
    cx: 8,
    cy: 8,
    r: 7.33333333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79166667,8.921875 L8.79166667,3.65104167 L7.21354167,3.65104167 L7.21354167,8.921875 L8.79166667,8.921875 Z M8.828125,12.0666667 L8.828125,10.4 L7.17708333,10.4 L7.17708333,12.0666667 L8.828125,12.0666667 Z",
    id: "!",
    fill: "#3796F6",
    fillRule: "nonzero",
    transform: "translate(8.002604, 7.858854) scale(1, -1) translate(-8.002604, -7.858854) "
  }))))))));
};

export default __webpack_public_path__ + "static/media/info_ico.dc1e3d1a.svg";
export { SvgComponent as ReactComponent };